exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current[data-v-6839a08d]{color:#000;font-size:16px;font-weight:500}.max-characters[data-v-6839a08d]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6839a08d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/products/components/ProductBreadcrumbs.vue
// module id = 553
// module chunks = 187